import * as React from 'react';
import { forwardRef } from 'react';

export type DMImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export const DMImage = forwardRef<HTMLImageElement, DMImageProps>(
  ({ className = '', alt = 'Image', ...props }, ref) => {
    return <img ref={ref} className={className} alt={alt} {...props} />;
  }
);
DMImage.displayName = 'DMImage';
